module.exports = ol.source.Vector;